<template>
  <div>
    <div class="flex justify-between">
      <div class="flex flex-col justify-between">
        <h4 class="text-h4">{{ header }}</h4>
        <div v-if="isLoadingPrices" class="w-full h-24 mb-8 animate-pulse bg-grey-divider-subdued" />
        <p v-else class="text-h4">
          {{ displayPrice }}
          <span v-if="strikethroughPrice" class="line-through text-small">{{ strikethroughPrice }}</span>
        </p>
      </div>
      <component :is="badge" :width="60" :height="60" />
    </div>
    <hr class="border-grey-divider-subdued my-16 hidden md-1:block" />
    <p class="text-strong-body mt-16 md-1:mt-0">{{ header }} includes…</p>
    <checkmark-list icon-color="#229150" :tips="checklistItems" class="mb-16 md-1:mb-48" />
    <span class="text-grey-clickable underline text-body cursor-pointer md-1:absolute md-1:bottom-24" @click="$emit('learnMore')"
      >Learn more</span
    >
  </div>
</template>

<script lang="ts">
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';

export default {
  name: 'BGCCardContent',
  components: {
    CheckmarkList,
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    displayPrice: {
      type: String,
      required: true,
    },
    strikethroughPrice: {
      type: String,
      required: false,
      default: null,
    },
    badge: {
      type: Object,
      default: null,
    },
    checklistItems: {
      type: Array,
      required: true,
    },
    isLoadingPrices: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
